import Store from '@material-ui/icons/Store';

import List from './List';

export default {
  list: List,
  icon: Store,
};
